import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangepwdUiComponent } from './change-password-ui.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { DirectivesModule } from '../../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
 
 

@NgModule({
  declarations: [ChangepwdUiComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule
  ],
  exports: [ChangepwdUiComponent]
})
export class ChangepwdUiModule { }
